import * as yup from 'yup';

export const stallDetectionValidationSchema = yup.object({
  cpuStallThresholdPercentage: yup
    .number()
    .min(0, 'Must be at least 0')
    .max(100, 'Must be at most 100')
    .required('CPU stall threshold is required'),
  minPressuredPodPercentage: yup
    .number()
    .min(0, 'Must be at least 0')
    .max(100, 'Must be at most 100')
    .required('Pod threshold is required'),
});
